export type ServiceCategory = "2d" | "3d";

export interface Service {
  slug: string;
  title: string;
  icon: string;
  category: ServiceCategory;
  summary: string;
  detail: string;
  duration: string;
  when: string;
}

export const serviceGroups: {
  id: ServiceCategory;
  label: string;
  caption: string;
  items: Service[];
}[] = [
  {
    id: "2d",
    label: "2D Dental Görüntüleme",
    caption:
      "İlk muayene, tarama ve ortodontik değerlendirme için temel dijital görüntüleme yöntemleri.",
    items: [
      {
        slug: "panoramik",
        title: "Panoramik Röntgen",
        icon: "ri-scan-2-line",
        category: "2d",
        summary:
          "Tüm dişleri, çene kemiklerini ve gömülü dişleri tek karede gösteren temel görüntüleme. Çürük taraması, kemik kaybı ve yirmilik diş tespiti.",
        detail:
          "Tek pozda alt ve üst çenenin tamamını gösterir. Rutin kontrol, çürük ve kemik kaybı taraması, gömülü yirmilik dişlerin konum tespiti ve genel tedavi planlaması için ilk tercih edilen görüntüdür.",
        duration: "~10 sn",
        when: "İlk muayene, genel tarama",
      },
      {
        slug: "panoral-5",
        title: "Panoral 5 · MultiSlice",
        icon: "ri-stack-line",
        category: "2d",
        summary:
          "Tek dozla 5 ayrı vertikal düzlemde panoramik görüntü. Kapanış bozukluğu veya hasta pozisyon hatası olan vakalarda ideal netlik.",
        detail:
          "MultiSlice teknolojisiyle 5 farklı düzlemde alınan görüntüler, tek katmanda netlik yakalanamayan vakalarda keskin sonuç sağlar. Servikal, orta ve anterior bölgeleri ayrı ayrı değerlendirme imkânı verir.",
        duration: "~12 sn",
        when: "Kapanış bozukluğu, pozisyon hatası",
      },
      {
        slug: "cocuk-panoramik",
        title: "Çocuk Panoramik",
        icon: "ri-user-smile-line",
        category: "2d",
        summary:
          "Çocuklar için özel görüntü alanı ve düşük doz protokolüyle çekilen panoramik. Pedodontik muayene ve büyüme-gelişim takibi.",
        detail:
          "Çocuk hastalar için optimize edilmiş düşük doz protokolü ve özel pozisyonlama ile alınır. Süt dişi–kalıcı diş geçişi, gelişim takibi ve erken müdahale planlamasında kullanılır.",
        duration: "~8 sn",
        when: "Pedodontik muayene, gelişim takibi",
      },
      {
        slug: "bite-wing",
        title: "Bite Wing",
        icon: "ri-grid-line",
        category: "2d",
        summary:
          "Çenelerin sağ-sol küçük azı ve büyük azı bölgesinden alınan görüntü. Özellikle aproksimal çürük ve dişler arası bölge detayı için.",
        detail:
          "Küçük ve büyük azı dişlerinin üst kısmını üstten-altan gösteren yüksek çözünürlüklü görüntüdür. Dişler arası başlangıç çürükleri ve mevcut restorasyonların takibi için idealdir.",
        duration: "~5 sn",
        when: "Aproksimal çürük, restorasyon takibi",
      },
      {
        slug: "sefalometrik",
        title: "Sefalometrik Röntgen",
        icon: "ri-user-line",
        category: "2d",
        summary:
          "Ortodontik tedavi (braket, şeffaf plak) ve ortognatik cerrahi planlaması için lateral, PA ve PA axial pozisyonlarda kafa ve çene görüntüsü.",
        detail:
          "Ortodontik tedavi ve ortognatik cerrahi planlamanın temel verisidir. Lateral, PA ve PA axial pozisyonlarda alınabilir; iskeletsel ölçüm ve sefalometrik analiz için kullanılır.",
        duration: "~10 sn",
        when: "Ortodonti, cerrahi planlama",
      },
      {
        slug: "el-bilek",
        title: "El-Bilek · Kemik Yaşı",
        icon: "ri-heart-pulse-line",
        category: "2d",
        summary:
          "Ortodontik tedavi ve implant planlamasında hastanın kemik yaşı ile büyüme-gelişim durumunu tespit etmek için. Greulich-Pyle atlası ile değerlendirme.",
        detail:
          "Sol el ve bilek bölgesinin görüntülenmesiyle iskeletsel olgunluk ve kemik yaşı belirlenir. Ortodontik tedavinin zamanlaması ve cerrahi kararlar için yol gösterir.",
        duration: "~5 sn",
        when: "Büyüme-gelişim, tedavi zamanlaması",
      },
      {
        slug: "tme-2d",
        title: "TME (2D) · Çene Eklemi",
        icon: "ri-record-circle-line",
        category: "2d",
        summary:
          "Çene ekleminde ağrı, klik sesi, kilitlenme ve bruksizm değerlendirmesi için panoramik ve PA axial film. İlk başvuru görüntülemesi.",
        detail:
          "Temporomandibular eklem (TME) şikâyetlerinde hızlı ve erişilebilir bir değerlendirme sağlar. Panoramik ile birlikte PA axial pozisyon kullanılarak eklem ilişkisi incelenir.",
        duration: "~10 sn",
        when: "Ağrı, klik, kilitlenme",
      },
    ],
  },
  {
    id: "3d",
    label: "3D Dental Tomografi (CBCT)",
    caption:
      "Hacimsel, milimetrik kesitsel görüntüleme. İmplant, gömülü diş, kist ve çene eklemi değerlendirmelerinde ileri tanı.",
    items: [
      {
        slug: "cbct",
        title: "3D Dental Tomografi (CBCT)",
        icon: "ri-box-3-line",
        category: "3d",
        summary:
          "Hacimsel, milimetrik kesitsel görüntü. İmplant planlama, gömülü diş analizi, kist/tümör değerlendirmesi ve çene kemiği yoğunluğu.",
        detail:
          "Cone Beam BT ile milimetrik kesitlerde üç boyutlu hacim elde edilir. İmplant yeri ve kemik yoğunluğu, sinir kanallarına mesafe, gömülü dişlerin komşulukları ve kist/tümör değerlendirmesinde standart haline gelmiştir.",
        duration: "~9-25 sn",
        when: "İmplant, gömülü diş, cerrahi",
      },
      {
        slug: "tme-cbct",
        title: "TME (CBCT) · 3D Çene Eklemi",
        icon: "ri-cpu-line",
        category: "3d",
        summary:
          "Çene eklemi kondil yüzeyi, eklem aralığı ve mandibular fossanın 3 boyutlu değerlendirmesi. Kronik ağrı, asimetri ve cerrahi planlama.",
        detail:
          "Kondil başı, eklem aralığı ve mandibular fossanın üç boyutlu incelenmesini sağlar. Kronik TME ağrısı, asimetri ve cerrahi planlamada detaylı anatomik değerlendirme sunar.",
        duration: "~25 sn",
        when: "Kronik ağrı, asimetri, cerrahi",
      },
    ],
  },
];

export const allServices: Service[] = serviceGroups.flatMap((group) => group.items);